<template>
  <div id="downTest">
    <div class="download_wrap">
      <div class="left_wrap">
        <img class="logo" src="../assets/img/logo_1.png" alt="">
        <div class="name">学习国防</div>
      </div>
      <div class="btn" @click="openApp">打开APP</div>
    </div>
    <div class="mcover" v-if="show">
      <p class="text">{{isIos() ? '请在safari浏览器中打开页面进行操作' : '请在系统自带浏览器中打开页面进行操作'}}</p>
      <div class="close" @click="closePage">我知道了</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "downTest",
  data() {
    return {
    };
  },
  mounted () {
  },
  methods: {
    closePage() {
      this.show = false;
    },
    openApp () {
      if (this.isWechat()) {
        this.show = true;
      } else {
        if (this.type === 1) {
          if (this.isIos()) {
            window.location.href = "studydefense://joinStudyGroup";
          } else {
            window.location.href = "android://h5/open?type=1&id=7";
          }
        } else {
          if (this.isIos()) {
            window.location.href = "studydefense://goHome";
          } else {
            window.location.href = "android://h5/open?type=1&id=8";
          }
        }
        setTimeout(() => {
          this.$router.push('/download');
        }, 3000);
      }
    }
  },
  props: ["type"]
};
</script>

<style lang="scss">
#downTest {
  .download_wrap{
    height:120px;
    width:100%;
    padding:0 30px;
    position:fixed;
    left:0;
    bottom:0;
    z-index:10;
    display:flex;
    align-items: center;
    justify-content: space-between;
    background:rgba($color: #000000, $alpha: 0.6);
    color:#fff;
    .left_wrap{
      display:flex;
      align-items: center;
      .logo{
        width:100px;
        height:100px;
        border-radius: 16px;
        margin-right:30px;
      }
      .name{
        font-size:32px;
        font-weight: bold;
      }
    }
    .btn{
      width:170px;
      height:72px;
      background:rgba(178,7,0,1);
      border-radius: 16px;
      line-height:72px;
      text-align:center;
      font-size:28px;
    }
  }
  .mcover{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba($color: #000000, $alpha: 0.8) url('../assets/img/icon_fenxiang_jiantou.png') no-repeat 560px 20px / 128px 100px;
    padding-top:200px;
    color:#fff;
    .text{
      font-size:40px;
      line-height:60px;
      padding: 0 100px;
    }
    .close{
      width:200px;
      height:80px;
      line-height:80px;
      text-align:center;
      margin:200px auto 0;
      background:gray;
      border-radius: 20px;
    }
  }
}
</style>
